import {
  Badge,
  Box,
  Button,
  Grid,
  Group,
  Input,
  Menu,
  MultiSelect,
  MultiSelectProps,
  rem,
  Select,
  Text,
} from "@mantine/core";
import {
  IconBarcode,
  IconBuildingWarehouse,
  IconCaretDown,
  IconFileExport,
  IconMapPin,
  IconRefresh,
  IconSearch,
  IconSwitch,
  IconX,
} from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  repositoryDelivery,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { paginationBase } from "../../../_base/model/_base/BaseTable";
import { _localization } from "../../../config/location";
import { SelectListItemModel } from "../../../model/SelectListItem";
import { exportDataToExcel } from "../../../common/ExportExcelToAPI/ExportExcelToAPI";
import { green } from "../../../const/variables";
import { BASE_API_DELIVERY } from "../../../config";
import { useForm } from "@mantine/form";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { MessageResponse } from "../../../model/MessageResponse";
import { NotificationExtension } from "../../../_base/extension/NotificationExtension";

interface SearchCriteria {
  keySearch?: string;
  level?: string;
}

const AccountInformation = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isRefetching, setIsRefetching] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [data, setData] = useState<InventoryItem[]>([]);
  const [rowCount, setRowCount] = useState(0);

  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {},
  });

  type InventoryItem = {
    id: number;
    accountantAccount: string;
    accountantAccountName: string;
    accountLevel: number;
    createBy: string | null;
    createDate: Date | null;
    lastUpdateDate: Date | null;
    lastUpdateBy: string | null;
    attribute1: string | null;
    attribute2: string | null;
    attribute3: string | null;
    attribute4: string | null;
    attribute5: string | null;
  };

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "accountantAccount",
        header: "Mã tài khoản kế toán",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            <Badge variant="light" color="violet">
              {renderedCellValue}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "accountantAccountName",
        header: "Tên tài khoản kế toán",
        size: 200,
      },
      {
        accessorKey: "accountLevel",
        header: "Cấp tài khoản",
      },
      {
        accessorKey: "attribute2",
        header: "Tài khoản cấp cha",
      },
      {
        accessorKey: "attribute4",
        header: "Tính chất tài khoản",
      },
      {
        accessorKey: "attribute5",
        header: "Hoạt động",
      },
      {
        accessorKey: "createBy",
        header: "Người tạo",
      },
      {
        accessorKey: "createDate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "lastUpdateBy",
        header: "Người cập nhật",
      },
      {
        accessorKey: "lastUpdateDate",
        header: "Ngày cập nhật",
        Cell: ({ renderedCellValue }: any) => (
          <>{formatDateTransfer(renderedCellValue)}</>
        ),
      },
    ],
    []
  );
  const SyncDmAccount = async () => {
    const res = await repositoryMdm.post<MessageResponse<any>>(
      "/api/v1/TblDmAccountance/sync-asia"
      // {
      //   type: "",
      //   title: "",
      //   status: 0,
      //   detail: "",
      //   instance: "",
      //   additionalProp1: "",
      //   additionalProp2: "",
      //   additionalProp3: "",
      // }
    );

    if (res && res?.success) {
      NotificationExtension.Success("Đồng bộ thành công");
      setTimeout(() => {
        fetchData();
      }, 2500);
    } else if (res?.httpStatusCode === 200) {
      NotificationExtension.Fails("Đồng bộ thất bại !");
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let url = `?Skip=${pagination?.pageIndex * pagination?.pageSize}&Take=${
      pagination.pageSize
    }`;
    const search = form.getValues();

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
    }
    if (search.level) {
      url += `&level=${search.level.trim().toLowerCase()}`;
    }
    try {
      const response = await repositoryDelivery.get(
        `/api/v1/TblDmAccounts/get-list${url}`
      );
      if (response && response.success) {
        let result = response.data;
        setData(result);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    // manualPagination: true,

    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "maSp", "transactionNumber", "sourceCode"],
        right: ["statusName"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    getRowId: (row) => row.departmentId,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (180 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  useEffect(() => {
    fetchData();
  }, [pagination]);
  return (
    <Box>
      <div style={{ border: "1px solid #dee2e6" }} ref={headerRef}>
        <Group gap={0} justify="space-between">
          <_breadcrumb></_breadcrumb>
        </Group>
        <Grid
          style={{
            margin: "10px",
          }}
        >
          <Grid.Col
            style={{
              display: "flex",
              gap: "10px",
              alignItems: "center",
              flexWrap: "wrap",
            }}
            span={7}
          >
            <Input
              placeholder="Nhập tìm kiếm"
              key={form.key("keySearch")}
              type="text"
              style={{ flex: 1, maxWidth: "200px" }}
              leftSection={<IconSearch size={"20"} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchData();
                }
              }}
              {...form.getInputProps("keySearch")}
            />
            <Select
              size="sm"
              placeholder="Cấp tài khoản"
              searchable
              key={form.key("level")}
              clearable
              data={[
                { value: "1", label: "Cáp 1" },
                { value: "2", label: "Cấp 2" },
                { value: "3", label: "Cấp 3" },
                { value: "4", label: "Cấp 4" },
              ]}
              style={{ flex: 1, maxWidth: "200px" }}
              leftSection={<IconSwitch size={20} color="#15aabf" />}
              {...form.getInputProps("level")}
            />
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchData();
              }}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
          <Grid.Col span={1} offset={3}>
            <Button
              color="blue"
              variant="light"
              leftSection={<IconRefresh size={17} />}
              bd="1px solid blue"
              onClick={() => {
                SyncDmAccount();
              }}
            >
              Đồng bộ tài khoản
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default AccountInformation;
